import { FC, ReactNode } from 'react';
import { containerStyle } from './DropDownContainer.styles.css';

type Props = {
    children: ReactNode;
    isActive?: boolean;
    isAlignedRight?: boolean;
};
export const DropdownContainer: FC<React.PropsWithChildren<Props>> = (
    props
) => {
    const { children, isActive = false, isAlignedRight } = props;
    return (
        <div className={containerStyle({ isActive, isAlignedRight })}>
            {children}
        </div>
    );
};
